import n from "./underscore.js";
function r(r, e) {
  return r._chain ? n(e).chain() : e;
}
export { r as default };